import { Chip, Divider, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";

const details = [
  {
    label: "Join path",
    value: "clicks.link_name → raw_brand_links_wp.link_name → brand_id",
  },
  {
    label: "Join filter",
    value: "raw_brand_links_wp.disabled = 0",
  },
  {
    label: "Join filter",
    chips: [
      { label: "traffic_type = 'Organic'", color: "default" },
      { label: "table_link_name = 'Not Reported'", color: "default" },
    ],
  },
];

const BrandJoin = () => {
  return (
    <>
      <Stack mb={1}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: "#00000099",
            fontSize: "14px",
            textTransform: "uppercase",
            mb: 0.5,
          }}
        >
          Brand Join
        </Typography>
        {details.map((item, index) => (
          <React.Fragment key={index}>
            <Typography
              fontSize={12}
              py={0.75}
              sx={{
                display: "flex",
              }}
            >
              <Box
                sx={{
                  width: "30%",
                  textTransform: "uppercase",
                  fontWeight: 400,
                }}
              >
                {item.label}
              </Box>

              <Box
                sx={{
                  width: "70%",
                }}
              >
                {item.value}

                {item.chips && (
                  <Stack
                    direction="row"
                    spacing={1}
                    mt={0.5}
                    flexWrap="wrap"
                    useFlexGap
                  >
                    {item.chips.map((chip) => (
                      <Chip
                        key={chip.label}
                        label={chip.label}
                        variant="outlined"
                        color={chip.color as "default" | "error"}
                        sx={{
                          borderRadius: 1,
                          fontSize: 12,
                          height: 22,
                          bgcolor:
                            chip.color === "error" ? "#FFF5F5" : "#FAFAFA",
                          "& .MuiChip-label": {
                            px: 0.75,
                          },
                        }}
                      />
                    ))}
                  </Stack>
                )}
              </Box>
            </Typography>

            {index !== details.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Stack>
    </>
  );
};

export default BrandJoin;
